import { useState } from "react";
import { Tabs, Input } from "antd";
import { Search } from "lucide-react";

import SaveSearchReport from "./SaveSearchReport";
import TagsReport from "./TagsReport";

const MyViewReport = ({ userId }) => {
  const [activeTab, setActiveTab] = useState("1");
  const [allTagSearch, setAllTagSearch] = useState("");

  const items = [
    {
      key: "1",
      label: "My Tags",
      children: <TagsReport allTagSearch={allTagSearch} userId={userId} />,
    },
    {
      key: "2",
      label: "Saved Searches",
      children: <SaveSearchReport userId={userId} />,
    },
  ];

  return (
    <section id="dashboard" className="tw-bg-[#f8fcff]">
      <Tabs
        className="tw-px-0 dashboard-tab"
        activeKey={activeTab}
        items={items}
        onChange={(key) => setActiveTab(key)}
        tabBarExtraContent={{
          right:
            activeTab === "1" ? (
              <div className="tw-w-[320px]">
                <Input
                  placeholder="Search Tags..."
                  prefix={<Search className="tw-w-4 tw-h-4 tw-text-slate-400" />}
                  value={allTagSearch}
                  onChange={(e) => setAllTagSearch(e.target.value)}
                />
              </div>
            ) : null,
        }}
      />
    </section>
  );
};

export default MyViewReport;
